import { queryClient } from '@/lib/queryClient';

/**
 * Creative 素材库「素材分页列表」的查询键前缀（`useMaterialPage` 用 `['material','page', params]`）。
 */
export const MATERIAL_PAGE_QUERY_KEY = ['material', 'page'] as const;

/**
 * 失效素材库的表格（素材列表）缓存。
 *
 * 上传任务是在后台把素材直传 OSS 再调 `/material/save` 入库的，素材库页面（KeepAlive 缓存）
 * 那边并不会自动知道有新素材 —— 只要**存在「上传并入库成功」的任务**，就必须主动失效一次，
 * 否则跳过去看到的还是缓存里的旧列表，看不到刚上传成功的素材。
 *
 * 幂等且廉价：没有对应缓存时是一次空操作，有缓存时让它在下次挂载 / 立即重新拉取。
 */
export const invalidateMaterialLibraryQueries = () => {
  void queryClient.invalidateQueries({ queryKey: MATERIAL_PAGE_QUERY_KEY });
};
